import { Controller, type FieldPath, type FieldValues } from 'react-hook-form';
import Button from '@/components/UI/Button';
import type { CheckboxProps } from '../../../Form/Checkbox';
import type { HookInputBaseProps } from '../../types';

export interface HookCheckboxProps<T extends FieldValues = FieldValues> extends CheckboxProps, HookInputBaseProps<T> {
  name: FieldPath<T>;
  onValueChange?: (newValue: boolean) => void;
}

export const HookToggle = <T extends FieldValues>(props: HookCheckboxProps<T>) => {
  const { name, required, validate, formMethods, label, onValueChange } = props;

  return (
    <Controller
      name={name}
      rules={{ required: required && 'Required', validate }}
      control={formMethods?.control}
      render={({ field }) => (
        <>
          <Button
            label={label}
            btnStyle={field.value ? 'btn-primary' : 'btn-neutral'}
            type='button'
            customClassName='w-24'
            disabled={field.disabled}
            onClick={() => {
              onValueChange?.(!field.value);
              field.onChange({ target: { value: !field.value } });
            }}
          />
        </>
      )}
    />
  );
};
